module.exports = __webpack_public_path__ + "static/media/block.33efc060.svg";